// Drag-data convention for schema-tree → VQE drop targets.
//
// Decoupled from `SchemaTreeDropTarget.tsx` so that file only exports React
// components (keeps `react-refresh/only-export-components` happy and HMR
// fast-refresh boundaries clean).

export const VQE_DRAG_TABLE_MIME = 'application/x-vqe-schema-table';

export type VqeDragTablePayload = {
  readonly name: string;
  readonly schema?: string;
  readonly database?: string;
  readonly quoted?: boolean;
};

export function parseVqeDragTablePayload(
  data: DataTransfer | null | undefined,
): VqeDragTablePayload | null {
  if (!data) return null;
  const raw = data.getData(VQE_DRAG_TABLE_MIME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && typeof parsed.name === 'string') {
      return parsed as VqeDragTablePayload;
    }
    return null;
  } catch {
    return null;
  }
}
